export const StartingMaterialDatasetProviders = {
  Cas: 'cas',
  Emolecules: 'emolecules',
  Mcule: 'mcule',
  Chemspace: 'chemspace',
  Molport: 'molport',
} as const;

export type StartingMaterialDatasetProvider =
  (typeof StartingMaterialDatasetProviders)[keyof typeof StartingMaterialDatasetProviders];

export type StartingMaterialPriceItem = {
  originalSmiles: string;
  normalizedSmiles: string;
  supplierId: string;
  availabilityTier: number;
  amount: number;
  price: number;
  compoundName: string;
  casNumber: string;
  versionId: string;
  datasetId: string;
  datasetName: string;
  supplierName: string;
};
